import {
  contractMonthYearParse,
  timeParseNoNull
} from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**s
 * Retrieves exposure data for commodities
 * @param {object} _this: context variables
 */
export function getExpoDataCommodities(_this) {
  const requestToken = _this.dataLoadToken || 0;
  _this.expoCommodities = [];
  _this.expo_commodities_deleted = [];
  let getPortfolioNumber = [];
  try {
    _this.selectedPortfolios.forEach(function(selectedPortfolio) {
      getPortfolioNumber.push(
        _this.companies[_this.selectedCompany].portfolios[selectedPortfolio.id]
          .pk_idportfolio
      );
    });
  } catch (error) {
    console.log("Portfolio list error");
  }

  let getCommodityNumber = [];
  try {
    for (var commodity in _this.selectedCommodity) {
      getCommodityNumber.push(
        _this.commoditySpecs.filter(
          com =>
            com.fk_idproduct.toUpperCase() ===
            _this.selectedCommodity[commodity].name
        )[0].pk_idcommodity
      );
    }
  } catch (error) {
    console.log("Commodity list error");
  }

  let params = {
    method: "GET",
    endpoint: "commodity-exposure",
    content_type: "application/json",
    query_params: {
      format: "json",
      commodity: { id_commodities: getCommodityNumber },
      portfolios: { id_portfolios: getPortfolioNumber }
    }
  };
  apiService
    .getAll(params)
    .then(data => {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        const commodity = _this.commoditySpecs.find(
          comm => comm.commodity_name === d.fk_idcommodity.toUpperCase()
        );
        const centsCurrency =
          commodity.is_cents && commodity.fk_idcurrency === "USD"
            ? "USc"
            : d.commodity_currency;
        d.pk =
          _this.companies[_this.selectedCompany].company_name
            .split(/\s/)
            .reduce((response, word) => (response += word.slice(0, 1)), "") +
          d.pk_idcommodity_exposure;
        d.continuation_month =
          d.continuation_month === 0 || d.continuation_month === ""
            ? null
            : d.continuation_month;
        d.fk_id_end_product = d.fk_id_end_product
          ? d.fk_id_end_product
          : d.fk_idcommodity.toUpperCase();
        d.fk_idcommodity = `${d.fk_idcommodity.toUpperCase()} (${centsCurrency}/${
          d.commodity_unit
        })`;
        d.quotation = d.commodity_currency + "/" + d.commodity_unit;
        d.date = timeParseNoNull(d.date);
        d.contract_month_year = contractMonthYearParse(d.contract_month_year);
        d.shipping_date = timeParseNoNull(d.shipping_date);
        d.sale_date = timeParseNoNull(d.sale_date);
      });
      _this.expoCommodities = data;
      _this.showLoadingExpoCommodities = false;
      _this.dataSavedExpoCommodities = true;
      _this.saveLegendExpoCommodities = "Saved:";
      _this.refreshLegendExpCommoditieso = "Synced:";
    })
    .catch(function(error) {
      if (requestToken !== (_this.dataLoadToken || 0)) return;
      _this.showLoadingExpoCommodities = false;
      _this.dataSavedExpoCommodities = true;
      _this.saveLegendExpoCommodities = "Saved:";
      _this.refreshLegendExpoCommodities = "Synced:";
      console.log(error);
    });
}
